// 复用ECharts排版后的文字范围，缓存坐标；逐帧只平移和淡入淡出，不重新排版图表。
export function collectScrollAxisLabels (chart, rect) {
  const model = chart.getModel().getComponent('xAxis', 0)
  const view = chart.getViewOfComponentModel && chart.getViewOfComponentModel(model)
  if (!view || !view.group || !view.group.traverse) return null
  const labels = [], width = chart.getWidth(), height = chart.getHeight()
  view.group.traverse(element => {
    if (element.type !== 'text' || element.ignore || element.invisible || !element.getBoundingRect) return
    const bounds = element.getBoundingRect().clone()
    if (element.transform) bounds.applyTransform(element.transform)
    if (!(bounds.width > 0 && bounds.height > 0) || bounds.y < rect.y + rect.height) return
    const x = Math.max(0, Math.floor(bounds.x - 2)), y = Math.max(0, Math.floor(bounds.y - 2))
    const right = Math.min(width, Math.ceil(bounds.x + bounds.width + 2)), bottom = Math.min(height, Math.ceil(bounds.y + bounds.height + 2))
    if (right > x && bottom > y) labels.push({ x, y, width: right - x, height: bottom - y })
  })
  return labels.sort((left, right) => left.x - right.x)
}

export function layoutScrollAxisLabels (labels, rect, shift) {
  const start = rect.x, end = start + rect.width, fade = Math.min(40, Math.max(16, rect.width * .05))
  const visible = []
  let previous = -Infinity
  labels.forEach(label => {
    const x = label.x - shift, right = x + label.width
    // 整个标签进入可读区域后再显示，避免时间文字被边缘截成半个数字。
    if (x < start || right > end || x < previous + 8) return
    const distance = Math.min(x - start, end - right), progress = Math.min(1, Math.max(0, distance / fade))
    if (!progress) return
    visible.push({ ...label, targetX: x, alpha: progress * progress * (3 - 2 * progress) })
    previous = right
  })
  return visible
}

export function paintScrollAxisLabels (ctx, track, labels, rect, shift, ratio) {
  ctx.save()
  layoutScrollAxisLabels(labels, rect, shift).forEach(label => {
    ctx.globalAlpha = label.alpha
    ctx.drawImage(track, label.x * ratio, label.y * ratio, label.width * ratio, label.height * ratio, label.targetX, label.y, label.width, label.height)
  })
  ctx.restore()
}
